export default __webpack_public_path__ + "static/uea-logo-black_magenta-4eecbabb399f843ea9a5bf65bdf54937.png";